import { SET_USER_ONLINE_STATUS } from "../actions/onlineActions";

const initialState = {
  usersOnline: {} // { userId: true/false }
};

export default function onlineReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_ONLINE_STATUS:
      return {
        ...state,
        usersOnline: {
          ...state.usersOnline,
          [action.payload.userId]: action.payload.isOnline
        }
      };
    default:
      return state;
  }
}
